import { OrderReminderState } from "@TKCCP/Store/Data/OrderReminder/OrderReminderState";
import { OrderEmailScheduleModel } from "@TKCCP/Types/ApiModels";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: OrderReminderState = {
    byId: {},
    isLoading: {},
    dataViews: {},
};

const reducer = {
    "Data/OrderReminder/BeginLoadOrderReminder": (
        
        draft: Draft<OrderReminderState>,
        action: { orderNumber: string },
    ) => {
        draft.isLoading[action.orderNumber] = true;
    },

    "Data/OrderReminder/CompleteLoadOrderReminder": (
        draft: Draft<OrderReminderState>,
        action: { orderNumber: string; model: OrderEmailScheduleModel | undefined },
    ) => {
        delete draft.isLoading[action.orderNumber];
        if (action.model) {
            draft.byId[action.orderNumber] = action.model;
        }
    },

    "Data/OrderReminder/Reset": () => {
        return initialState;
    },
};

const orderReminderReducer = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).orderReminder = orderReminderReducer;
